import * as actionTypes from './actionsTypes';

export const setallowreg=(payload)=>{
    return {
        type:actionTypes.SETALLOWREG,
        value:payload
    }
}